import {Scroll} from '../helpers/scroll';
import {headerHeight} from '../helpers/header-height';
import {breakpoints} from '../helpers/constants';

export class ScrollToAnchor {

	constructor(elem) {
		this.elem = elem;

		this.anchors = document.querySelectorAll('a[href^="#"]');

		this.addEventHandlers();
		this.eventHeaderHeight = headerHeight.setEventsPageHeaderHeight();
		this.siteHeaderHeight = headerHeight.setSiteHeaderHeight();

		if (!breakpoints.isMedium() && this.eventHeaderHeight > 0) {
			this.eventHeaderHeight -= 20; // -20 px because eventHeader shrinks 20px on desktop
		}
	}

	addEventHandlers() {
		for (let i = 0; i < this.anchors.length; i++) {
			this.anchors[i].addEventListener('click', (event) => {
				event.preventDefault();
				let id = event.currentTarget.getAttribute('href');
				id = id.substring(1);
				const scrollTarget = document.getElementById(id);
				if (scrollTarget) {
					const topOffset = scrollTarget.getBoundingClientRect().top;
					if (topOffset === this.siteHeaderHeight + this.eventHeaderHeight - 1) {
						// Now the screen doesn't have to scroll because I'm already on the correct position.
						return;
					}
					if (topOffset >= this.siteHeaderHeight + this.eventHeaderHeight) {
						// Scroll down
						Scroll.scrollPageTo(scrollTarget, 500, this.eventHeaderHeight);
					} else {
						// Scroll up
						Scroll.scrollPageTo(scrollTarget, 500, this.eventHeaderHeight + this.siteHeaderHeight);
					}
				}
			})
		}
	}
}

